  <template>
  <div id="app" class="app">
    <div class="top">
      <div class="logo">
        <i class="logo_icon"></i>
        <span>绿叶助手</span>
      </div>
      <!-- <a href="https://www.apple.com/cn/itunes/charts/" class="download_btn">立即下载</a> -->
    </div>
    <div class="model_body">
      <div class="model">
        <h3>功能展示</h3>
        <div class="swiper">
          <ul class="img_list">
            <li class="img_item" v-for="(item, index) in imgList" :key="index">
              <img :src="item.url">
            </li>
          </ul>
        </div>
      </div>
      <div class="model">
        <h3>描述：</h3>
        <p>绿叶助手是一款功能强大兼顾图片编辑、营销素材制作及团队照片云端共享的工具类APP。</p>
        <p>产品功能：</p>
        <p>新建画布：提供4种画布尺寸，可自由在画布上进行写画。</p>
        <p>文字：支持图片上添加不同颜色的文字，标记属于自己的瞬间。</p>
        <p>画笔：可自由设置画笔颜色，满足不同需求。</p>
        <p>马赛克：支持图片打码，遮盖照片上不想被人看到的私人信息。</p>
        <p>裁剪图片：支持图片自由裁剪及旋转。</p>
        <p>图片水印：支持图片上添加文字水印，防止他人盗图。</p>
        <p>二维码装饰：支持二维码图片加色彩边框，多种边框风格自由选择。</p>
        <p>图片拼图：支持多张图片合成一张长图，拼出属于自己的照片墙。</p>
        <p>九宫格切图：支持照片裁切成九宫格样式，将照片在社交网络上发布，快速夺人眼球。</p>
        <p>晒单模板：支持多种晒单模板背景选择，让晒单图瞬间高大上。</p>
        <p>修色滤镜：为你喜欢的照片自由搭配各种滤镜。</p>
        <p>团队相册：支持团队成员创建、管理和云端相册，评价、讨论和点赞照片内容，高效支持团队协同。</p>
      </div>
      <div class="model">
        <h3>意见反馈</h3>
        <p>如遇问题或者有好的建议，欢迎加入绿叶助手用户QQ群（597848001），向客服反馈！</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {
  },
  data () {
    return {
      imgList: [{
        url: require('./assets/img1.jpg')
      }, {
        url: require('./assets/img2.png')
      }, {
        url: require('./assets/img3.png')
      }, {
        url: require('./assets/img4.png')
      }, {
        url: require('./assets/img5.png')
      }]
    }
  }
}
</script>

<style>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  background: no-repeat 0 0;
  background-size: 100% auto;
  font-size: inherit;
  font-weight: normal;
  font-style: normal;
  text-decoration: none;
  line-height: inherit;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
html {
  font-size: 12px;
}
body {
  height: auto;
  -webkit-user-select: none;
  user-select: none;
  background-color: #ffffff
}
li {
    list-style: none;
}
button {
    outline: none;
}
a {
  text-decoration: none;
  color: inherit;
}
#app {
  width: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0 auto;
}
.logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 2em 0 1em;
}
.logo_icon {
  border: 1px solid #eee;
  width: 5em;
  height: 5em;
  background-image: url('./assets/logo.png');
  background-size: 86% auto;
  background-position: center;
  border-radius: .8em;
}
.logo span {
  color: #323232;
  font-size: 1.2em;
  font-weight: 500;
  line-height: 2.2em;
}
.download_btn {
  display: block;
  font-size: 1.2em;
  color: #fff;
  width: 70%;
  height: 2em;
  line-height: 2em;
  border-radius: 2em;
  margin: 0 auto;
  text-align: center;
  background-color: rgb(75, 116, 200)
}
.model_body {
  padding: 0 4% 2em;
}
.model {
  margin-bottom: 1.6em;
}
.model h3 {
  font-size: 1.1em;
  font-weight: 500;
  line-height: 3em;
  color: rgb(34, 34, 34);
  display: flex;
  align-items: center;
}
.model p{
  font-size: .9em;
  line-height: 1.8em;
  letter-spacing: 1px;
  color: rgb(73, 71, 71);
}
.model p span {
  color: rgb(75, 116, 200);
}
.model_icon {
  width: 1em;
  height: 3em;
  background-image: url('./assets/award.png');
  background-position-y: .86em;
  margin-right: .2em;
}
.swiper {
  white-space: nowrap;
  overflow-x: auto;
}
.img_item {
  display: inline-block;
  width: 16em;
  margin-right: .6em;
}
.img_item img {
  width: 100%;
}
</style>
